import { useState } from 'react';
import Card from '../../common/Card';
import Label from '../../common/Label';
import Button from '../../common/Button';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setToastsError, setToastsSuccess } from '../../../redux/actions/common';
import ProhibitedForm from '../../layout/ITHeadquarters/ProhibitedForm';
import Checkbox from '../../common/Checkbox';
import { setLoader } from '../../../redux/actions/api';
import { ExceptionControllerService, ProhibitedControllerService } from '../../../services';
import apiErrorHandler from '../../../api/apiErrorHandler';
import Input from '../../common/Input';
import { clearErrors } from '../../../redux/actions/error';

const ProhibitedCategoryRegister = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { isException } = props;

    const DEFAULT_STATUS = {
        lines: [],
        classes: [],
        subclasses: [],
        selectedDepartment: null,
        selectedLine: null,
        selectedClass: null,
        selectedSubclass: null,
        deleteFlag: isException ? undefined : false,
        selectedLowestPriceType: 'COMPETITOR',
        selectedDeleteFlag: false,
        markupFlag: false,
        markupRate: null,
    };

    const [state, setState] = useState(DEFAULT_STATUS);

    const {
        selectedDepartment,
        selectedLine,
        selectedClass,
        selectedSubclass,
        selectedLowestPriceType,
        selectedDeleteFlag,
        markupFlag,
        markupRate,
    } = state;

    const handleChangeState = (field, value) => {
        setState((prevState) => ({
            ...prevState,
            [field]: value,
        }));
    };

    const handleSubmitForm = () => {
        dispatch(clearErrors());
        const isValid = validateSubmitItem();
        if (isValid) return;

        dispatch(setLoader(true));
        const formData = {
            departmentCode: selectedDepartment.value,
            lineCode: selectedLine?.value ?? null,
            classCode: selectedClass?.value ?? null,
            subclassCode: selectedSubclass?.value ?? null,
            lowestPriceType: selectedLowestPriceType,
            deleteFlag: selectedDeleteFlag,
            ...(!isException && {
                markupRate: markupFlag ? markupRate : null,
            }),
        };
        const request = isException
            ? ExceptionControllerService.upsertExceptionCategory(formData)
            : ProhibitedControllerService.upsertProhibitedCategory(formData);
        request
            .then(() => {
                const title = isException ? '例外カテゴリー' : '禁止カテゴリー';
                dispatch(setToastsSuccess(title + 'を更新しました。'));
            })
            .catch((error) => {
                apiErrorHandler(dispatch, error, t('message.error.update'));
            })
            .finally(() => {
                dispatch(setLoader(false));
            });
    };

    const validateSubmitItem = () => {
        if (selectedDepartment === null) {
            dispatch(setToastsError('部門を選択してください。'));
            return true;
        }
        if (markupFlag && (markupRate === null || markupRate === '' || !/^\d+$/.test(markupRate) || markupRate < 0 || markupRate > 99)) {
            dispatch(setToastsError('値入率は0~99の整数で入力してください。'));
            return true;
        }
    };

    const handleClearForm = () => {
        setState(DEFAULT_STATUS);
    };

    const handleChangeType = () => {
        setState((prevState) => ({
            ...prevState,
            apiResponse: null,
            page: 1,
        }));
    };

    return (
        <div className="okc-container prohibited-products">
            <div className="okc-inner">
                <div className="okc-title fade-in">{t('prohibited_product_registration.form.title')}</div>
            </div>
            <ProhibitedForm state={state} setState={setState} handleClear={handleClearForm} onChangeType={handleChangeType} />
            <div className="okc-card fade-in">
                <div className="okc-card__header">{isException ? '例外設定' : '禁止設定'}</div>
                <Card type="modal_card">
                    <div className="row okc-card__row">
                        <Label
                            type="column"
                            className="col-lg-2 mb-2 mb-lg-4"
                            text={t('exception_product_registration.setting.status.title')}
                        />
                        <div className="col-lg-4 pr-lg-3 mb-4">
                            <div className="row m-0">
                                <Checkbox
                                    column="col-xl-3 col-lg-4 col-md-5"
                                    label={isException ? '例外' : '禁止'}
                                    onChange={() => handleChangeState('selectedDeleteFlag', !selectedDeleteFlag)}
                                    value={!selectedDeleteFlag} // ’有効'に対してdeleteFlagのため反転
                                    checked={!selectedDeleteFlag}
                                />
                            </div>
                        </div>
                        {!isException && (
                            <>
                                <div className="col-lg-2 pl-lg-3 mb-4">
                                    <div className="row m-0">
                                        <Checkbox
                                            column="col-xl-3 col-lg-4 col-md-5"
                                            label={t('exception_product_registration.setting.markup.label')}
                                            onChange={() => {
                                                handleChangeState('markupFlag', !markupFlag);
                                                handleChangeState('markupRate', null);
                                            }}
                                            value={markupFlag}
                                            checked={markupFlag}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 pr-lg-3 mb-4">
                                    <div className="m-0 markup-rate">
                                        <Input
                                            className="form-control form-control--input"
                                            value={markupRate || ''}
                                            type="text"
                                            maxLength="2"
                                            autoComplete="off"
                                            onChange={(value) => {
                                                handleChangeState('markupRate', value);
                                            }}
                                            disabled={!markupFlag}
                                        />
                                        <span>％</span>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </Card>
            </div>
            <div className="d-flex c-slide-top mb-5">
                <Button className="btn btn--primary btn-block" id="registration-btn" onClick={handleSubmitForm}>
                    <span className="btn-text">{t('exception_product_registration.button.update')}</span>
                </Button>
            </div>
        </div>
    );
};
export default ProhibitedCategoryRegister;
